module.exports = __webpack_public_path__ + "media/usp-recipes-2628c7bf.svg";